import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "d-flex justify-end ga-3" }

import { computed, reactive, ref } from 'vue';
import { useRouter } from 'vue-router';
import { toast } from '@/lib/toast';
import api from '../api';

import ProcedurePage from "../components/ProcedurePage.vue";
import DecisionGrid from "../components/application/DecisionGrid.vue";

interface Procedure {
  id?: number
  registryNumber?: string
  type?: string
  goodName?: string
  subject?: string
  startMaxPrice?: string
  applicationDeadline?: null
  reviewDeadline?: null
  shippingCondition?: string
  publishedAt?: null
  organizerName?: string
  isNds?: boolean
  isClosed: boolean
  step: {
    name: string
    code: string
  }
  [key: string]: any
}

interface Application {
  isAccepted?: boolean
  [key: string]: any
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ProcedureReview',
  setup(__props) {

const procedure = reactive<Procedure>({
  id: null,
  registryNumber: '',
  type: '',
  goodName: '',
  subject: '',
  startMaxPrice: '',
  applicationDeadline: null,
  shippingCondition: '',
  publishedAt: null,
  organizerName: '',
  isNds: null,
  isClosed: false,
  step: { name: '', code: '' },
});
const applications = ref<Application[]>([]);
const types = ref<{
  title: string
  value: string
}[]>([]);
const loading = ref(false);

const valid = computed<boolean>(() => !applications.value.find(
    ({ isAccepted }) => isAccepted === null)
);

const load = async procedureId => {
  const resp = await api.get(`/procedures/${procedureId}/review`);
  Object.assign(procedure, resp.procedure);
  applications.value = resp.applications;
  types.value = resp.types.map((elem) => ({
    title: elem.name,
    value: elem.code,
  }));
};

const router = useRouter();
const goToProcedures = () => router.push({ name: 'procedures.all' });

const confirm = async procedureId => {
  try {
    loading.value = true;
    const formData = new FormData();
    formData.append('data', JSON.stringify(applications.value));
    await api.post(`/procedures/${procedureId}/review`, formData);
    toast.info('Процедура обновлена успешно');
    goToProcedures();
  } catch (e) {
    toast.error(e.message);
  } finally {
    loading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(ProcedurePage, {
    id: _ctx.$route.params.id,
    procedure: procedure,
    "load-func": load,
    status: procedure.step,
    types: types.value,
    isClosed: procedure.isClosed,
    "onUpdate:procedureGoodName": _cache[1] || (_cache[1] = ($event: any) => (procedure.goodName = $event)),
    "onUpdate:procedureType": _cache[2] || (_cache[2] = ($event: any) => (procedure.type = $event))
  }, {
    default: _withCtx(() => [
      (procedure.id)
        ? (_openBlock(), _createBlock(DecisionGrid, {
            key: 0,
            procedureId: procedure.id,
            "procedure-type": procedure.type,
            status: procedure.step.code,
            applications: applications.value,
            isNds: procedure.isNds,
            successful: null
          }, null, 8 /* PROPS */, ["procedureId", "procedure-type", "status", "applications", "isNds"]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_v_btn, {
          flat: "",
          color: "primary",
          density: "comfortable",
          variant: "outlined",
          onClick: goToProcedures
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Отмена')), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_v_btn, {
          flat: "",
          color: "primary",
          density: "comfortable",
          variant: "elevated",
          disabled: !valid.value,
          loading: loading.value,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (confirm(_ctx.$route.params.id)))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Подтвердить')), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["disabled", "loading"])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["id", "procedure", "status", "types", "isClosed"]))
}
}

})